import { getBadges } from '../app/features/dashboard/components/helpers';
import { IDataTableColumn } from '../app/common/types/dataTable';
import {
    Link,
    matchPath,
    useNavigate,
} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCheck,
    faCheckCircle,
    faChevronCircleRight,
    faClockRotateLeft,
    faEdit,
    faHistory
} from '@fortawesome/free-solid-svg-icons';
import { AESEncrypt } from '../app/../encrypt-util';
import { toast } from 'react-toastify';
import { faBell, faBellSlash } from '@fortawesome/free-solid-svg-icons';
import { useAmountFormatter } from './useAmountFormatter';
import { useDispatch } from 'react-redux';
import { gateInfoGateIn, gateInfoGateOut } from '../app/features/blRequestInstruction/components/actions/Instruction';
import { AppDispatch, RootState } from '../app/features/template/store';
import { useSelector } from 'react-redux';
import { Button } from "react-bootstrap";
import useDataCountry from './useDataCountry';
import { getUnprefixedPathname } from '../helpers/utils';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { getSezOpenDocumentUrl } from '../app/features/sezDashboard/SezActions';
import { openDocumentFromUrl } from '../helpers/openDocumentInNewTab';


export interface IRequestConfig {
    accessor: string | null;
    columnId: string | number | null;
    dataType: string | null;
    filterType: string | null;
    filterValues: any[] | null;
    filterable: string | boolean | null;
    fixed: string | boolean | null;
    hide: boolean | null;
    hyperlink: string | null;
    label: string | null;
    sort_order: string | null;
    sortable: string | boolean | null;
    timeFormat: string | null;
    tooltip: string | null;
    type: string | null;
    visible: string | boolean | null;
    width: string | number | null;
    link: string | null | any;
    hyperLink: string | null;
    slider: string | null | any;
    assert?: any;
}
export interface IConfigsDefinition {
    columns: IDataTableColumn[];
    staticHiddenCols: string[];
    defaultHiddenCols: string[];
}

export function useGenerateColumnConfig() {
    const formatNumber = useAmountFormatter()
    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate()
    const dataCountry = useDataCountry()
    const LinerId = useSelector(
        (state: RootState) => state.navbarTop.linerId
      );
    
    const profileDetails = useSelector(
            (state: RootState) => state.userProfile.profile
            );
    return (
        configs: IRequestConfig[],
        getParams?: () => any
    ): IConfigsDefinition => {
        const generateHeaderLabel = (s: any) => {
            let count = 1;
            for (let i in s) {
                if (s.charAt(i) === s.charAt(i).toUpperCase()) {
                    count++;
                }
            }
            return count ? `resource_${count}:${s}` : s;
        };
        const columnConfigs: any = configs.map((c) => {
            const commonKeys = {
                accessor: c?.accessor || null,
                Header: c?.label? c.label : c?.accessor ? generateHeaderLabel(c.accessor) : '',
                minWidth: c?.width
                    ? typeof c?.width === 'string'
                        ? parseInt(c.width) - 60
                        : c.width - 60
                    : 120,
                width: c?.width
                    ? typeof c?.width === 'string'
                        ? parseInt(c.width)
                        : c.width
                    : 120,
                maxWidth: c?.width
                    ? typeof c?.width === 'string'
                        ? parseInt(c.width) + 100
                        : c.width + 100
                    : 300,
                columnFilterType: c?.filterType || null,
                columnFilterOptions: c?.filterValues || null,
                disableSort: c?.sortable === 'false' ? true : false,
                fixed: c?.fixed === 'true' || c?.fixed ? true : false,
                link: c?.link || null,
                hyperLink: c?.hyperLink || null,
                slider: c?.slider || null,
                hide: c?.hide || false,
            };


            return {
                ...commonKeys,
                Cell: (rowData: any) => {
                    const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';
                    if(c?.accessor == "gateIN"|| c?.accessor == "gateOut"){
                         const gateIn = c.accessor == "gateIN"
                        return <Button   onClick={()=>{
                            //const gateIn = c.accessor == "gateIN"
                                            const payload:any = [rowData.row.original].map((x:any)=>({
                                            blId: x.bl_id,
                                            containerNo:x.container_no,
                                            gateIn:gateIn?new Date() || '':null,
                                            gateInTo:gateIn?profileDetails.partnerName:null,
                                            gateOut:!gateIn?new Date() || '':null,
                                            gateOutFrom: !gateIn?profileDetails.partnerName:null,
                                            linerId: LinerId,
                                            countryCode: dataCountry,
                                            doNumber:x.do_number,
                                            doDate:x.do_date ,
                                            validTillDate:x.do_validity_date,
                                            emptyReturnDate:x.empty_return_date,
                                            emptyYardName:x.empty_yard_name,
                                            emptyYardAddress:x.empty_yard_address,
                                            companyName:x.customer_name
                            
                                          }))
                                         
                                          dispatch(gateIn?gateInfoGateIn(payload):gateInfoGateOut(payload))
                        }} size={'sm'} disabled={true} variant='falcon-primary'  className='me-0 mt-0 p-1 fs--1'>
                            {gateIn? <span><FontAwesomeIcon icon={'arrow-right'} className='fs--1'/> Gate In </span>
                            :<span><FontAwesomeIcon  icon={'arrow-left'} className='fs--1 ' style={{color:"#f5822a"}}/> Gate Out
                            </span> }</Button>
                      }
                    if (c?.accessor == "ebl_available") {
                        
                        // rowData.row.original?.ebl_available === "Y" 
                        const isEBLAvailable = rowData.row.original?.ebl_available === "Y";
                        const blId = rowData.row.original?.blid
                        const blIdEncrypted = AESEncrypt(blId);

                        return (isEBLAvailable)
                            ? (<span
                                onClick={() => {
                                    if (!isEBLAvailable) {
                                        return
                                    }
                                    navigate(`/ebl/${blIdEncrypted}`)
                                }}
                                className={`me-0 mt-0 p-1 infoIcon cursor-pointer ms-1 fs--1 ${!isEBLAvailable ? 'disabled' : ''}`}
                            >
                                {
                                    (isEBLAvailable) ? <FontAwesomeIcon
                                        icon={faEdit}
                                        className='ps-1'
                                        style={{ color: '#f5822a' }}
                                        size='lg'
                                    />
                                        : <span>
                                        </span>}
                            </span>) : (<></>)
                    }
                    if (c?.accessor?.toLowerCase?.() === 'sez_history') {
                        const certId =
                            rowData?.row?.original?.sez_cert_req_id ||
                            rowData?.row?.original?.id;
                        if (!certId) {
                            return '';
                        }

                        return (
                        <span
  onClick={(e) => {
    e.preventDefault();
    navigate(
      `${APP_PATH_PREFIX}/sezDashboard/history/${AESEncrypt(
        String(certId)
      )}`
    );
  }}
  className="text-primary cursor-pointer"
  title="View History"
>
  <FontAwesomeIcon icon={faClockRotateLeft} />
</span>
                        );
                    }
                    const value = c?.accessor
                        ? c?.dataType === 'datetime' || c?.dataType === 'date'
                            ? rowData?.row?.original?.[c.accessor]
                                ? new Date(rowData?.row?.original?.[c.accessor])
                                : ''
                            : rowData?.row?.original?.[c.accessor]
                        : '';
                    const getSelection = (path: string, encrypt = true) => {
                        const params = getParams ? getParams() : {};

                        let returnResponse = false;
                        //  const pattern = /:[A-Za-z]*/g;
                        const pattern = /:\w*/g;

                        const variables = path.match(pattern);

                        const combineLogicFields = ['inst_id', 'doc_id'];
                        const combineLogicFields2 = ['request_id'];
                        if (c?.accessor === 'inst_type' && combineLogicFields?.length > 0) {
                            let comibneLogicDecider = [];
                            if (
                                variables &&
                                variables?.length > 0 &&
                                matchPath(path, getUnprefixedPathname())
                            ) {
                                for (let i of variables) {
                                    const variable = i.slice(1);
                                    const value = rowData?.row?.original?.[variable];

                                    if (
                                        combineLogicFields.includes(variable) &&
                                        value &&
                                        variable &&
                                        params?.[variable] === value
                                    ) {
                                        comibneLogicDecider.push(variable);
                                    }
                                }
                            }

                            return comibneLogicDecider?.length === combineLogicFields?.length;
                        }
                        else if (c?.accessor === 'request_id' && combineLogicFields?.length > 0) {
                            let comibneLogicDecider = [];
                            if (
                                variables &&
                                variables?.length > 0 &&
                                matchPath(path, getUnprefixedPathname())
                            ) {
                                for (let i of variables) {
                                    const variable = i.slice(1);
                                    const value = rowData?.row?.original?.[variable];
                                    if (
                                        combineLogicFields2.includes(variable) &&
                                        value &&
                                        variable &&
                                        params?.[variable] === value
                                    ) {

                                        comibneLogicDecider.push(variable);
                                    }
                                }
                            }

                            return comibneLogicDecider?.length === combineLogicFields2?.length;
                        } else if (c?.accessor == 'instruction_name') {
                            if (
                                variables &&
                                variables?.length > 0 /* && */
//                                 window.location.pathname.includes(':bl_id')
                            ) {
                                for (const i of variables) {
                                    const variable = i.slice(1);
                                    const value = rowData?.row?.original?.[variable];
                                    console.log("Value: ", value, "Variable: ", variable, "Params: ", params?.[variable]);
                                    if (value && variable && params?.[variable] === value) {
                                        returnResponse = true;
                                    }
                                }
                            }
                        }
                        else {
                            if (
                                variables &&
                                variables?.length > 0 &&
                                matchPath(path, getUnprefixedPathname())
                            ) {
                                for (let i of variables) {
                                    const variable = i.slice(1);
                                    const value = rowData?.row?.original?.[variable];

                                    if (value && variable && params?.[variable] === value) {
                                        returnResponse = true;
                                    }
                                }
                            }
                        }

                        return returnResponse;
                    };

                    const unPrefixedPathname = (path: string) => { return path.replace('/hl', ''); }
                    const normalizeSezCertificatePath = (path: string) => {
                        return path
                            .replace(/\/sezdashboard\b/gi, '/sezDashboard')
                            .replace(
                                '/sezDashboard/certificate/:sez_cert_req_id/:status/review',
                                '/sezDashboard/certificate/:sez_cert_req_id/review'
                            )
                            .replace(
                                '/sezDashboard/certificate/:sez_cert_req_id/:status',
                                '/sezDashboard/certificate/:sez_cert_req_id'
                            );
                    };
                    const getSezNavState = (path: string) => {
                        if (!path.toLowerCase().includes('/sezdashboard/certificate/')) {
                            return undefined;
                        }
                        const row = rowData?.row?.original || {};
                        return {
                            status: String(row.status || row.Status || ''),
                        };
                    };
                    const handleSezCertificateNavigation = (
                        event?: React.MouseEvent,
                        path?: string
                    ) => {
                        const routePath = path || '';
                        if (!routePath.toLowerCase().includes('/sezdashboard/certificate/:sez_cert_req_id')) {
                            return true;
                        }

                        const status = String(
                            rowData?.row?.original?.status ||
                                rowData?.row?.original?.Status ||
                                ''
                        );


                        if (routePath.toLowerCase().includes('/review')) {
                            return true;
                        }


                        return true;
                    };
                    const checkColumnAssert = (event?: React.MouseEvent) => {
                        if (!c?.assert?.field) {
                            return true;
                        }

                        const rawFieldVal = String(
                            rowData?.row?.original?.[c.assert.field] ??
                                rowData?.row?.original?.status ??
                                rowData?.row?.original?.Status ??
                                ''
                        );
                        const fieldVal = rawFieldVal.toUpperCase();
                        const expected = String(c.assert.value ?? '').toUpperCase();


                        if (fieldVal !== expected) {
                            event?.preventDefault();
                            toast.error(
                                `${
                                    c?.assert?.errormsg ||
                                    'Unable to open link'
                                } Current status: ${rawFieldVal || '-'}`
                            );
                            return false;
                        }

                        return true;
                    };
                    const getRouteLink = (path: string, encrypt = true) => {
                        const routePath = normalizeSezCertificatePath(path);
                        let returnPath = APP_PATH_PREFIX + routePath;

                        const pattern = /:[A-Za-z_]*/g;

                        const variables = routePath.match(pattern);
                        if (variables && variables?.length > 0) {
                            for (let i of variables) {
                                const variable = i.slice(1);

                                const value = rowData?.row?.original?.[variable];

                                if (value)
                                    returnPath = returnPath.replace(
                                        i,
                                        encrypt &&
                                            //   variable !== 'inst_id' &&
                                            //  variable !== 'doc_id' &&
                                            variable !== 'id' &&
                                            variable !== 'instructionid' &&
                                            variable !== 'doc_number'
                                            ? AESEncrypt(value)
                                            : value
                                    );
                            }
                        }

                        if (
                            c?.hyperlink?.includes('/openDocument') &&
                            !c?.hyperlink?.match(/[?&]linerId=:[A-Za-z_]+/)
                        ) {
                            const staticLinerId = c.hyperlink.match(
                                /[?&]linerId=([^&:]+)/
                            )?.[1];

                            if (staticLinerId) {
                                returnPath = returnPath.replace(
                                    /([?&]linerId=)[^&]*/,
                                    `$1${AESEncrypt(staticLinerId)}`
                                );
                            }
                        }

                      if (
                            variables?.includes(':bl_id') &&
                            variables?.includes(':standing_instruction_id')
                        ) {
                            const parts = returnPath.split('/');
                            if (parts.length >= 3) {
                                const thirdPosition = parts[3];
                                parts[3] = AESEncrypt(thirdPosition);

                                return parts.join('/');
                            }
                        }
                        return returnPath;
                    };

                    const setTimeFormat = (val: string) => {
                        try {
                            return c?.dataType === 'date' || c?.dataType === 'datetime'
                                ? val
                                    ? c?.dataType === 'date'
                                        ? new Date(val).toLocaleDateString(
                                            new Intl.DateTimeFormat().resolvedOptions().locale,
                                            { timeZone: 'UTC' }
                                        )
                                        : new Date(val).toLocaleString()
                                    : ''
                                : val;
                        } catch (e) {
                            return val;
                        }
                    };

                    const getLink = (value: string | null | any) => {
                        if (c?.accessor === 'snoozed' || c?.accessor === 'snoozenotification') {
                            return (
                                <div>
                                    {/*  <FontAwesomeIcon
                    icon={faBell}
                     className='text-primary ps-1'
                     size='lg'
                    /> */}
                                    <Link
                                        to={getRouteLink(`${c?.link}${window.location.search || ''}`)}
                                        className={`${getSelection(c?.link) ? 'fw-bold' : 'text-primary'
                                            }`}
                                    >
                                        {value === 'Yes' ?
                                            <FontAwesomeIcon
                                                icon={faBell}
                                                className='text-primary ps-1'
                                                size='lg'
                                            /> : value === 'No' ? <FontAwesomeIcon
                                                icon={faBellSlash}
                                                className='text-danger ps-1 '
                                                size='lg'
                                            /> : ''}
                                    </Link>

                                </div>
                            )
                        }
                        else if (c?.link && c?.slider) {
                            return (
                                <div>
                                    <Link
                                        to={
                                            rowData?.row?.original?.[c?.assert?.field] !==
                                                c?.assert?.value
                                                ? getRouteLink(window.location.pathname)
                                                : window?.location?.search
                                                    ? getRouteLink(`${c?.link}${window.location.search}`)
                                                    : getRouteLink(c?.link)
                                        }
                                        state={getSezNavState(c?.link || '')}
                                        onClick={(event) => {
                                            if (!checkColumnAssert(event)) {
                                                return;
                                            }
                                            handleSezCertificateNavigation(event, c?.link || '');
                                        }}
                                        className={`${getSelection(c?.link) || getSelection(c?.slider)
                                                ? 'fw-bold'
                                                : 'text-primary'
                                            }`}
                                    >
                                        {value}
                                    </Link>
                                    {value&&<span
                                        onClick={() => {
                                            if (!checkColumnAssert()) {
                                                return;
                                            }
                                            navigate(
                                                window?.location?.search
                                                    ? `${getRouteLink(c?.slider)}${window.location.search
                                                    }`
                                                    : getRouteLink(c?.slider),
                                                { state: getSezNavState(c?.slider || '') }
                                            );
                                        }}
                                        className='infoIcon cursor-pointer ms-1'
                                    >
                                        <FontAwesomeIcon icon={faChevronCircleRight} />
                                    </span>}
                                </div>
                            );
                        } else if (
                            c?.link &&
                            !(rowData?.row?.original?.doc_category === 202) &&
                            value
                        ) {
                            return (
                                <Link
                                    to={getRouteLink(`${c?.link}${window.location.search || ''}`)}
                                    state={getSezNavState(c?.link || '')}
                                    onClick={(event) => {
                                        if (!checkColumnAssert(event)) {
                                            return;
                                        }
                                        handleSezCertificateNavigation(event, c?.link || '');
                                    }}
                                    className={`${getSelection(c?.link) ? 'fw-bold' : 'text-primary'
                                        }`}
                                >
                                    {value}
                                </Link>
                            );
                        } else if (c?.slider && value) {
                            return (
                                <div>
                                    <span className={`${getSelection(c?.slider) ? 'fw-bold' : ''}`}>
                                        {value}
                                    </span>
                                    <span
                                        onClick={() => {
                                            if (!checkColumnAssert()) {
                                                return;
                                            }
                                            if (
                                                !handleSezCertificateNavigation(
                                                    undefined,
                                                    c?.slider || ''
                                                )
                                            ) {
                                                return;
                                            }
                                            if (navigate)
                                                navigate(
                                                    window?.location?.search
                                                        ? `${getRouteLink(c?.slider)}${window.location.search
                                                        }`
                                                        : getRouteLink(c?.slider),
                                                    { state: getSezNavState(c?.slider || '') }
                                                );
                                        }}
                                        className='infoIcon cursor-pointer ms-1'
                                    >
                                        <FontAwesomeIcon icon={faChevronCircleRight} />
                                    </span>
                                </div>
                            );
                        } else if (
                            c?.accessor === 'sez_cert' ||
                            (c?.hyperlink || '').includes('/api/edo-rest-v2/v1/sez/openDocument')
                        ) {
                            const rowStatus = String(
                                rowData?.row?.original?.status || ''
                            ).toUpperCase();

                            if (rowStatus === 'PENDING') {
                                return null;
                            }

                            const certId =
                                rowData?.row?.original?.sez_cert_req_id ||
                                rowData?.row?.original?.id;
                            if (!certId) {
                                return value || '';
                            }

                            const linerIdValue =
                                profileDetails?.partnerType === 'liner'
                                    ? profileDetails?.partnerId
                                    : LinerId;

                            if (!linerIdValue) {
                                return value;
                            }

                            return (
                                <span
                                    onClick={(e) => {
                                        e.preventDefault();
                                        window.open(
                                            getSezOpenDocumentUrl(certId, linerIdValue),
                                            '_blank',
                                            'noopener,noreferrer'
                                        );
                                    }}
                                    className='text-primary cursor-pointer'
                                >
                                    {'View Certificate'}
                                </span>
                            );
                        } else if (c?.hyperlink) {
                            // container deposit invoice PDF for PIL do not exist
                            if (rowData?.row?.original?.invtypecode == 880 && c?.accessor == 'invno') {
                                return <span>{value}</span>
                            }

                            if (
                                rowData?.row?.original?.[c?.assert?.field] === c?.assert?.value
                            ) {
                                return (
                                    <span
                                        onClick={(e) => {
                                        e.preventDefault();

                                        const path = unPrefixedPathname(
                                            getRouteLink(c?.hyperlink || '')
                                        );

                                        openDocumentFromUrl(path);
                                        }}
                                        className='text-primary cursor-pointer'
                                    >
                                        {value}
                                    </span>
                                );
                            } else {
                                return (
                                    <span
                                        onClick={(e) => {
                                            e.preventDefault();
                                            toast.error(c?.assert?.errormsg || 'Unable to open link');
                                        }}
                                        className='text-primary cursor-pointer'
                                    >
                                        {value}
                                    </span>
                                );
                            }
                        } else {
                            if (c?.accessor == 'invamt' || c?.accessor == 'pmt_amt' || c?.accessor == 'localamt' || c?.accessor == 'amount'|| c?.accessor == 'final_amount' || c?.accessor == 'inv_amt') {
                                const newVal = formatNumber(value, 
                                    {ccy:
                                        c?.accessor == 'localamt' ?'KES' :
                                        c?.accessor == 'inv_amt'?rowData?.row?.original?.inv_curr:
                                        c?.accessor == 'pmt_amt'?rowData?.row?.original?.currency:
                                        c?.accessor == 'final_amount'?rowData?.row?.original?.inv_curr:
                                        rowData?.row?.original?.invcurr}
                                );
                                return <div className='text-end'>{newVal}</div>;
                            } else {
                                return value;
                            }
                        }
                    };

                    if (c?.tooltip) {
                        const tooltipValue = rowData?.row?.original?.[c.tooltip];

                        return (
                            <div
                                className='text-truncate'
                                data-toggle='tooltip'
                                title={tooltipValue || value}
                            >
                                {c?.type === 'badge'
                                    ? getBadges(value)
                                    : getLink(setTimeFormat(value || ''))}
                            </div>
                        );
                    } else {
                        if (c?.accessor === 'pmtstatus') {
                            return value === 'Yes' ? (
                                <FontAwesomeIcon
                                    icon={faCheckCircle}
                                    className='text-primary ps-1'
                                    size='lg'
                                />
                            ) : value === 'No' ? (
                                ''
                            ) : (
                                <div
                                    className='text-truncate'
                                    data-toggle='tooltip'
                                    title={value}
                                >
                                    {c?.type === 'badge' ? getBadges(value) : ''}
                                </div>
                            );
                        }else  if (c?.accessor == 'extflag') {
                            return value == 'Y' ? (
                                <FontAwesomeIcon
                                    icon={faCheckCircle}
                                    className='text-primary ps-1'
                                    size='lg'
                                />
                            ) : value == 'N' ? (
                                ''
                            ) : (
                                <div
                                    className='text-truncate'
                                    data-toggle='tooltip'
                                    title={value}
                                >
                                    {c?.type === 'badge' ? getBadges(value) : ''}
                                </div>
                            );
                        }else

                            if (c?.accessor === 'is_final_amt_available') {
                                  console.log('Cell value:', c?.accessor,value);
                                     
                            return value === 'Y' ?
                         (
                            
                                <FontAwesomeIcon
                                    icon={faCheckCircle}
                                    className='text-primary ps-1'
                                    size='lg'
                                />
                            ) : value === 'N' ? (
                                ''
                            ) : (
                                <div
                                    className='text-truncate'
                                    data-toggle='tooltip'
                                    title={value}
                                >
                                    {c?.type === 'badge' ? getBadges(value) : ''}
                                </div>
                            );
                        }
                        return (
                            <div
                                className='text-truncate'
                                data-toggle='tooltip'
                                title={setTimeFormat(value || '')}
                            >
                                {c?.type === 'badge'
                                    ? getBadges(value)
                                    : getLink(setTimeFormat(value || ''))}
                            </div>
                        );
                    }
                },
            };
        });
        return {
            columns: columnConfigs,
            staticHiddenCols: configs
                .filter((c: any) => c?.hide === 'true' || c?.hide)
                .map((c: any) => c.accessor),
            defaultHiddenCols: configs
                .filter((c: any) => c?.visible === 'false')
                .map((c: any) => c.accessor),
        };
    };
}

